'use strict';

var DataExtractCompletedPanelDirective = function DataExtractCompletedPanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/data-extract-completed.html'),
    controller: 'DataExtractCompletedController'
  };
};
DataExtractCompletedPanelDirective.$inject = [];
module.exports = DataExtractCompletedPanelDirective;